<div class="black-bg">
  <div class="wgv-page">
    <div class="hero-section">
      <div class="texture-overlay"></div>
      <div class="content">
        <p class="presenter">WGV E ANTONIO MORRA PRESENTANO:</p>
        <div class="logo-title">
          <!-- <span class="wgv-logo">WGV</span> -->
          <h1 class="title">UNFILTERED</h1>
        </div>
        <p class="subtitle">
          Una conferenza senza <span class="accent">filtri</span>
        </p>
        <div class="temi">
          <ul>
            <li>Relazioni</li>
            <li>Sessualità</li>
            <li>P*rnøgrafi&#64;</li>
          </ul>
        </div>
        <div class="event-details">
          <div class="time-block">
            <p class="date">SABATO <span class="accent">17</span> GENNAIO</p>
            <span class="time">START ORE 17:00</span>
          </div>
          <p class="with">con</p>
          <div class="speaker-block">
            <span class="antonio">
              <img src="/images/antonio-min.png" alt="Antonio Morra" />
            </span>
            <span class="speaker">ANTONIO MORRA</span><br />
            <div class="address-block">Via Taramelli 8/10, LODI</div>
            <!-- <div class="time-block">
              <p class="date">SABATO <span class="accent">17</span> GENNAIO</p>
              <span class="time">START ORE 17:00</span>
            </div> -->
          </div>
        </div>
      </div>
      <br /><br />
    </div>

    <div class="registration-section">
      <h2>ISCRIVITI ALL'EVENTO</h2>
      <p class="info">Compila il form per confermare la tua partecipazione</p>

      <form class="registration-form" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <div class="form-group">
            <label for="nome">Nome</label>
            <input
              type="text"
              id="nome"
              name="nome"
              [(ngModel)]="nome"
              placeholder="Il tuo nome"
              required
            />
          </div>
          <div class="form-group">
            <label for="cognome">Cognome</label>
            <input
              type="text"
              id="cognome"
              name="cognome"
              [(ngModel)]="cognome"
              placeholder="Il tuo cognome"
              required
            />
          </div>
        </div>
        <br />

        <div class="form-group panino-selection">
          <label>Scegli il tuo panino</label>
          <div class="radio-group">
            <label class="radio-option">
              <input
                type="radio"
                name="tipoPanino"
                value="cotto"
                [(ngModel)]="tipoPanino"
              />
              <span class="radio-custom"></span>
              <span class="radio-label">Cotto</span>
            </label>
            <label class="radio-option">
              <input
                type="radio"
                name="tipoPanino"
                value="crudo"
                [(ngModel)]="tipoPanino"
              />
              <span class="radio-custom"></span>
              <span class="radio-label">Crudo</span>
            </label>
          </div>
          <span class="label-note">+ scamorza e insalata</span>
        </div>
        <br />

        <div class="form-group bibita-selection">
          <label>Scegli la tua bibita</label>
          <div class="radio-group">
            <label class="radio-option">
              <input
                type="radio"
                name="bibita"
                value="pepsi"
                [(ngModel)]="bibita"
              />
              <span class="radio-custom"></span>
              <span class="radio-label">Pepsi</span>
            </label>
            <label class="radio-option">
              <input
                type="radio"
                name="bibita"
                value="fanta"
                [(ngModel)]="bibita"
              />
              <span class="radio-custom"></span>
              <span class="radio-label">Fanta</span>
            </label>
            <label class="radio-option">
              <input
                type="radio"
                name="bibita"
                value="acqua-naturale"
                [(ngModel)]="bibita"
              />
              <span class="radio-custom"></span>
              <span class="radio-label">Acqua naturale</span>
            </label>
            <label class="radio-option">
              <input
                type="radio"
                name="bibita"
                value="acqua-frizzante"
                [(ngModel)]="bibita"
              />
              <span class="radio-custom"></span>
              <span class="radio-label">Acqua frizzante</span>
            </label>
          </div>
        </div>
        <br />

        <div class="form-group checkbox-group">
          <label class="checkbox-option">
            <input
              type="checkbox"
              name="senzaGlutine"
              [(ngModel)]="senzaGlutine"
            />
            <span class="checkbox-custom"></span>
            <span class="checkbox-label">Senza glutine</span>
          </label>
          <label class="checkbox-option">
            <input
              type="checkbox"
              name="senzaLattosio"
              [(ngModel)]="senzaLattosio"
            />
            <span class="checkbox-custom"></span>
            <span class="checkbox-label">Senza lattosio</span>
          </label>
        </div>

        <button
          type="submit"
          class="submit-btn"
          [disabled]="
            !nome || !cognome || !tipoPanino || !bibita || isSubmitting
          "
        >
          {{ isSubmitting ? "INVIO IN CORSO..." : "INVIA ISCRIZIONE" }}
        </button>

        @if (successMessage) {
        <div class="message success-message">{{ successMessage }}</div>
        } @if (errorMessage) {
        <div class="message error-message">{{ errorMessage }}</div>
        }
      </form>
    </div>
  </div>
</div>
